import { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

/** A video set drawn by code (`domain/scenes/`), offered next to the media manager's template groups. */
export type BuiltInVideoSetId = 'night-stadium' | 'sport-slash';

/** In the order the picker lists them; the first is the default when the championship has no set with an intro. */
export const BUILT_IN_VIDEO_SET_IDS: readonly BuiltInVideoSetId[] = ['night-stadium', 'sport-slash'];

export const BUILT_IN_VIDEO_SET_LABELS: Record<BuiltInVideoSetId, MessageDescriptor> = {
  'night-stadium': msg`Ночной стадион`,
  'sport-slash': msg`Спортивный скос`,
};
